import { render } from "./UpdateAanmeldenTarieven.vue?vue&type=template&id=50622b10&scoped=true"
import script from "./UpdateAanmeldenTarieven.vue?vue&type=script&lang=js"
export * from "./UpdateAanmeldenTarieven.vue?vue&type=script&lang=js"

import "./UpdateAanmeldenTarieven.vue?vue&type=style&index=0&id=50622b10&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50622b10"]])

export default __exports__